import { httpService, IPlan, IUser } from 'shared';

export const authApi = {
  me: async () => {
    const { data } = await httpService.get<IUser>('/users/me');

    return data;
  },
  getCurrentPlan: async () => {
    return await httpService.get<IPlan[]>(`/memberships?Active=true`);
  }
};
